// Deep import: the aos-ds barrel runs createModal/createButton/cssInterop at
// module scope, so importing it here would execute all of that at app startup.
import { Spinner } from 'aos-ds/src/primitives/spinner/Spinner'
import React, { FC } from 'react'

import { Center } from '../center'

export interface CenteredSpinnerProps {
    inContent?: boolean
}

export const CenteredSpinner: FC<CenteredSpinnerProps> = ({ inContent }) => (
    <Center className={inContent ? 'h-full w-full' : 'absolute inset-0'}>
        <Spinner />
    </Center>
)
